import { Container, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Like from "../Assets/Like.svg";
import Blue from "../Assets/Blue.svg";

function ConditionLabel() {
  return (
    <Container fluid className="Forecast">
      <Row>
        <h5>Classification:</h5>
      </Row>
      <Card className="ColorLabel_card">
        <Card.Body className="ColorLabel_body">
          <div>
            <table>
              <tr>
                <td>
                  <img
                    src={Like}
                    className="ColorLabel_box"
                    alt=""
                    width="20px"
                    height="20px"
                  />
                </td>
                <td>Heatwave-Like Condition</td>
              </tr>
              <tr>
                <td>
                  <img
                    src={Blue}
                    className="ColorLabel_box"
                    alt=""
                    width="20px"
                    height="20px"
                  />
                </td>
                <td>No Heatwave-Like Condition</td>
              </tr>
            </table>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default ConditionLabel;
